<template>
        <v-tooltip top>
            <v-btn fab dark small :color="bc.color_hex" slot="activator" @click="$emit('ColorChange', bc.color_id)">
                <v-icon v-if="value === bc.color_id" class="cc" dark>done</v-icon>
            </v-btn>
            <span>{{ bc.color_name }}</span>
        </v-tooltip>
</template>
<script>
export default {
  props: {
    value: Number,
    bc: Object,
  }
};
</script>
<style>
    .cc {
        text-shadow: 0 0 1px #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/widgets/color/OrderColor.vue